import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f73f399"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  style: {"margin-top":"20px"},
  class: "ta-c"
}
const _hoisted_5 = { class: "general" }
const _hoisted_6 = {
  key: 0,
  class: "modal7"
}
const _hoisted_7 = { class: "contenedor7" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, " Seleccione el Centro ", -1))
const _hoisted_9 = { class: "contenido7" }
const _hoisted_10 = { class: "contenido7" }
const _hoisted_11 = { id: "customers" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "NOMBRE"),
  /*#__PURE__*/_createElementVNode("th", null, "REGION"),
  /*#__PURE__*/_createElementVNode("th", null, "PROVINCIA")
], -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "modalConfirm"
}
const _hoisted_15 = { class: "contenedor" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Notificación", -1))
const _hoisted_17 = { class: "contenido" }
const _hoisted_18 = { class: "contenido" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Afiliado Validado Exitosamente ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Afiliado")
], -1))
const _hoisted_21 = { class: "grid" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "cedula"
}, "CEDULA:", -1))
const _hoisted_23 = { class: "lds-ripple" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre"
}, "NOMBRE:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "apellido"
}, "APELLIDO:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "sexo"
}, "SEXO:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "MASCULINO", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "FEMENINO", -1))
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fechaNacimiento"
}, "NACIMIENTO:", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "edad"
}, "EDAD:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nss"
}, "NSS:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "regimen"
}, "REGIMEN:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "SUBSIDIADO", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "CONTRIBUTIVO", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PENSIONADO", -1))
const _hoisted_40 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "direccion"
}, "DIRECCION:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "telefono"
}, "TELEFONO:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo_de_contacto"
}, "TIPO DE CONTACTO:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PROPIO", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "PROMOTOR DE SALUD", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "GESTOR DE SALUD", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "OTROS", -1))
const _hoisted_48 = [
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "tipo_de_contacto"
}, "ESPECIFIQUE:", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre_contacto"
}, "NOMBRE DE CONTACTO:", -1))
const _hoisted_51 = ["disabled"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de la Evaluación")
], -1))
const _hoisted_53 = { class: "grid" }
const _hoisted_54 = { class: "grid" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "fecha"
}, "FECHA:", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "unap"
}, "UNAP:", -1))
const _hoisted_57 = ["disabled"]
const _hoisted_58 = ["onClick", "value"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "supervisor"
}, "SUPERVISOR:", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "unap"
}, null, -1))
const _hoisted_61 = { class: "grid-short" }
const _hoisted_62 = { class: "grid" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "comentary"
}, "COMENTARIO:", -1))
const _hoisted_64 = ["disabled"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Guardar ")
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = ["disabled"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" Actualizar ")
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print" }, null, -1))
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Imprimir ")
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Eliminar ")
const _hoisted_77 = [
  _hoisted_75,
  _hoisted_76
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_Navbar),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (_ctx.cargando)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("img", {
                  class: "img",
                  src: 'https://cruzjiminian-assets-bucket.s3.amazonaws.com/webapp/images/logo.png'
                }, null, 8, _hoisted_2),
                _hoisted_3,
                _createElementVNode("h6", _hoisted_4, _toDisplayString(this.estadoLoading), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        (_ctx.showModalAseguradoras)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        id: "search",
                        type: "search",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                        class: "form-control",
                        placeholder: "Introduzca el nombre del centro",
                        onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buscar()))
                      }, null, 544), [
                        [_vModelText, _ctx.search]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("table", _hoisted_11, [
                        _hoisted_12,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$store.state.user
                        .filteredCentros, (centro, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            onClick: ($event: any) => (_ctx.setCentro(centro))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(centro.unap), 1),
                            _createElementVNode("td", null, _toDisplayString(centro.region), 1),
                            _createElementVNode("td", null, _toDisplayString(centro.provincia), 1)
                          ], 8, _hoisted_13))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showModalConfirm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (this.showModalConfirmMethod())),
                    for: "btn-modal"
                  }, "X"),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("button", {
                      class: "btn btn-success",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (this.showModalConfirmMethod()), ["prevent"]))
                    }, " Validar Otro Afiliado "),
                    _createElementVNode("button", {
                      class: "btn btn-info",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (this.$router.push('/evaluacions')), ["prevent"]))
                    }, " Ver Listado ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", null, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.encabezado), 1),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", null, [
                _hoisted_22,
                _withDirectives(_createElementVNode("div", _hoisted_23, _hoisted_26, 512), [
                  [_vShow, _ctx.showSpinner]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "cedula",
                  type: "cedula",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.defCedula())),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.evaluacion.cedula) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.cedula]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  id: "nombre",
                  type: "nombre",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.evaluacion.nombre) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.nombre]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                _withDirectives(_createElementVNode("input", {
                  id: "apellido",
                  type: "apellido",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.evaluacion.apellido) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.apellido]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_29,
                _withDirectives(_createElementVNode("select", {
                  id: "sexo",
                  type: "sexo",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.evaluacion.sexo) = $event)),
                  class: "form-select"
                }, _hoisted_32, 512), [
                  [_vModelSelect, _ctx.evaluacion.sexo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_33,
                _withDirectives(_createElementVNode("input", {
                  id: "fechaNacimiento",
                  type: "date",
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.calcularEdad(_ctx.evaluacion.fechaNacimiento))),
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.evaluacion.fechaNacimiento) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.fechaNacimiento]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  disabled: "",
                  id: "edad",
                  type: "Number",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.evaluacion.edad) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.edad]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_35,
                _withDirectives(_createElementVNode("input", {
                  id: "nss",
                  type: "nss",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.evaluacion.nss) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.nss]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_36,
                _withDirectives(_createElementVNode("select", {
                  disabled: "",
                  id: "regimen",
                  type: "regimen",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.evaluacion.regimen) = $event)),
                  class: "form-select"
                }, _hoisted_40, 512), [
                  [_vModelSelect, _ctx.evaluacion.regimen]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  id: "direccion",
                  type: "direccion",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.evaluacion.direccion) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.direccion]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  id: "telefono",
                  type: "telefono",
                  onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.defTelefono())),
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.evaluacion.telefono) = $event)),
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.evaluacion.telefono]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_43,
                _withDirectives(_createElementVNode("select", {
                  id: "tipo_de_contacto",
                  type: "tipo_de_contacto",
                  onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setContactName())),
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.evaluacion.tipo_de_contacto) = $event)),
                  class: "form-select"
                }, _hoisted_48, 544), [
                  [_vModelSelect, _ctx.evaluacion.tipo_de_contacto]
                ])
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _hoisted_49,
                _withDirectives(_createElementVNode("input", {
                  id: "especificacion_contacto",
                  type: "especificacion_contacto",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.evaluacion.especificacion_contacto) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.especificacion_contacto]
                ])
              ], 512), [
                [_vShow, this.evaluacion.tipo_de_contacto == 'OTROS']
              ]),
              _createElementVNode("div", null, [
                _hoisted_50,
                _withDirectives(_createElementVNode("input", {
                  disabled: this.evaluacion.tipo_de_contacto == 'PROPIO',
                  id: "nombre_contacto",
                  type: "nombre_contacto",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.evaluacion.nombre_contacto) = $event)),
                  class: "form-control"
                }, null, 8, _hoisted_51), [
                  [_vModelText, _ctx.evaluacion.nombre_contacto]
                ])
              ])
            ]),
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", null, [
                  _hoisted_55,
                  _withDirectives(_createElementVNode("input", {
                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.fechaState())),
                    id: "fecha",
                    type: "date",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.evaluacion.fecha) = $event)),
                    class: "form-control"
                  }, null, 544), [
                    [_vModelText, _ctx.evaluacion.fecha]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_56,
                  _withDirectives(_createElementVNode("select", {
                    disabled: this.lockCentro,
                    id: "unap",
                    type: "unap",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.evaluacion.id_center) = $event)),
                    class: "form-select",
                    onFocus: _cache[25] || (_cache[25] = ($event: any) => (this.showModalAseguradorasMethod()))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.$store.state.user
                        .filteredCentros, (centro, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        onClick: ($event: any) => (_ctx.setCentro(centro)),
                        value: centro.id_center
                      }, _toDisplayString(centro.unap), 9, _hoisted_58))
                    }), 128))
                  ], 40, _hoisted_57), [
                    [_vModelSelect, _ctx.evaluacion.id_center]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_59,
                  _withDirectives(_createElementVNode("input", {
                    disabled: "",
                    id: "supervisor",
                    type: "supervisor",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.evaluacion.supervisor) = $event)),
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.evaluacion.supervisor]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _hoisted_60,
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: _cache[27] || (_cache[27] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectImage && _ctx.selectImage(...args)), ["prevent"])),
                        class: "btn btn-outline-primary px-4"
                      }, " Seleccionar Escáner SIRS ")
                    ])
                  ])
                ], 512), [
                  [_vShow, 
                    _ctx.evaluacion.fecha &&
                      _ctx.evaluacion.cedula &&
                      _ctx.evaluacion.nombre &&
                      _ctx.evaluacion.apellido &&
                      _ctx.evaluacion.sexo &&
                      _ctx.evaluacion.fechaNacimiento &&
                      _ctx.evaluacion.edad &&
                      _ctx.evaluacion.nss &&
                      _ctx.evaluacion.regimen &&
                      _ctx.evaluacion.direccion &&
                      _ctx.evaluacion.telefono &&
                      _ctx.evaluacion.tipo_de_contacto &&
                      _ctx.evaluacion.nombre_contacto &&
                      _ctx.evaluacion.supervisor &&
                      _ctx.evaluacion.unap
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", null, [
                _hoisted_63,
                _withDirectives(_createElementVNode("textarea", {
                  id: "comentary",
                  type: "comentary",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.evaluacion.comentary) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.evaluacion.comentary]
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("button", {
              disabled: 
                !_ctx.evaluacion.fecha ||
                  !_ctx.evaluacion.cedula ||
                  !_ctx.evaluacion.nombre ||
                  !_ctx.evaluacion.apellido ||
                  !_ctx.evaluacion.sexo ||
                  !_ctx.evaluacion.fechaNacimiento ||
                  !_ctx.evaluacion.edad ||
                  !_ctx.evaluacion.nss ||
                  !_ctx.evaluacion.regimen ||
                  !_ctx.evaluacion.direccion ||
                  !_ctx.evaluacion.telefono ||
                  !_ctx.evaluacion.tipo_de_contacto ||
                  !_ctx.evaluacion.nombre_contacto ||
                  !_ctx.evaluacion.supervisor ||
                  !_ctx.evaluacion.unap
              ,
              class: "btn btn-primary",
              onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.createEvaluacion()), ["prevent"]))
            }, _hoisted_67, 8, _hoisted_64), [
              [_vShow, this.evaluacion.consAfil]
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "imageInput",
                type: "file",
                ref: "fileInput",
                onInput: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                accept: "image/*"
              }, null, 544), [
                [_vShow, false]
              ])
            ]),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-success",
                  onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
                  disabled: 
                !_ctx.evaluacion.facNo ||
                  !_ctx.evaluacion.nombPres ||
                  !_ctx.evaluacion.codPres ||
                  !_ctx.evaluacion.aut ||
                  !_ctx.evaluacion.fechAutor ||
                  !_ctx.evaluacion.nombARS ||
                  !_ctx.evaluacion.autPor ||
                  !_ctx.evaluacion.montRec ||
                  !_ctx.evaluacion.nombPac ||
                  !_ctx.evaluacion.cedu ||
                  !_ctx.evaluacion.aflNSS ||
                  !_ctx.evaluacion.sex ||
                  !_ctx.evaluacion.edad ||
                  !_ctx.evaluacion.dir ||
                  !_ctx.evaluacion.dx
              
                }, _hoisted_71, 8, _hoisted_68))
              : _createCommentVNode("", true),
            (this.modoForm == 'show')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-warning",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (this.$router.push(`/evaluacions2/${_ctx.evaluacion._id}`)))
                }, _hoisted_74))
              : _createCommentVNode("", true),
            (_ctx.showDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-danger",
                  onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
                }, _hoisted_77))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.cargando]
      ])
    ])
  ]))
}